import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../app/store/utils/baseQueryWithReauth';
import {
  ILogin,
  IUser,
  IUserResponse,
} from '../common/interfaces/iUser.interface';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    login: build.mutation<IUserResponse, ILogin>({
      transformResponse: (response: { data: IUserResponse }) => response.data,
      query: data => ({
        url: '/system/auth/sign-in',
        method: 'POST',
        body: data,
      }),
    }),
    forgotPassword: build.mutation<any, { email: string }>({
      transformResponse: (response: { data: any }) => response.data,
      query: email => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body: email,
      }),
    }),
    resetPassword: build.mutation<any, { password: string; token: string }>({
      transformResponse: (response: { data: any }) => response.data,
      query: data => ({
        url: '/auth/reset-password',
        method: 'POST',
        body: data,
      }),
    }),
    signUp: build.mutation<any, any>({
      transformResponse: (response: { data: any }) => response.data,
      query: data => ({
        url: '/auth/sign-up',
        method: 'POST',
        body: data,
      }),
    }),
    loginAsClient: build.mutation<any, { phone: string; verificationCode?: string }>({
      transformResponse: (response: { data: any }) => response.data,
      query: data => ({
        url: '/auth/client/sign-in',
        method: 'POST',
        body: data,
      }),
    }),
    getUser: build.query<IUser, string>({
      transformResponse: (response: { data: IUser }) => response.data,
      query: () => ({
        url: '/system/users/profile',
        method: 'GET',
      }),
    }),
    updateProfile: build.mutation<IUser, Partial<IUser>>({
      transformResponse: (response: { data: IUser }) => response.data,
      query: (data) => ({
        url: '/system/users/profile',
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
});
